import { useMemo } from 'react';
import { useBulkPlaybookUpdateTableContext } from 'ion-experimental/app/bulk-playbook-update/BulkPlaybookUpdateTableContext';

export default function useBulkPlaybookUpdateTable() {
  const {
    pipelines,
    loading,
    selectedPipelineIds,
    setSelectedPipelineIds,
    handleSelectAll,
    onlyShowSelected,
    perPage,
    setPerPage,
    perPageOptions,
    setSort,
    clearSelectedKey,
  } = useBulkPlaybookUpdateTableContext();

  // Filter data based on "show selected only"
  const data = useMemo(() => {
    if (onlyShowSelected && selectedPipelineIds.size > 0) {
      return pipelines.filter(pipeline => selectedPipelineIds.has(pipeline.id));
    }
    return pipelines;
  }, [pipelines, onlyShowSelected, selectedPipelineIds]);

  // Selection change handler - wires ReactDataTable selection to context state
  const handleSelectedRowsChange = ({ allSelected, selectedCount, selectedRows }) => {
    if (allSelected) {
      handleSelectAll(true);
    } else if (selectedCount === 0) {
      handleSelectAll(false);
    } else {
      const selectedIds = new Set(selectedRows.map(row => row.id));
      setSelectedPipelineIds(selectedIds);
    }
  };

  // Handle sort changes
  const handleSort = (column, direction) => {
    setSort({ field: column.sortField, direction });
  };

  // Handle rows per page changes
  const handlePerPageChange = newPerPage => {
    setPerPage(newPerPage);
  };

  return {
    data,
    loading,
    progressPending: loading,

    // Selection
    selectableRows: true,
    selectableRowsHighlight: true,
    selectableRowsVisibleOnly: onlyShowSelected,
    noContextMenu: true,
    onSelectedRowsChange: handleSelectedRowsChange,
    clearSelectedRows: clearSelectedKey,

    // Sorting (still server-side since we re-fetch on sort change)
    onSort: handleSort,
    sortServer: true,

    // Pagination (client-side)
    pagination: true,
    paginationPerPage: perPage,
    paginationRowsPerPageOptions: perPageOptions,
    onChangeRowsPerPage: handlePerPageChange,
    paginationComponentOptions: {
      noRowsPerPage: false,
      rowsPerPageText: 'Rows per page:',
      rangeSeparatorText: 'of',
    },
  };
}
